import IconCalendar from "components/Icons/IconCalendar";
import { Formaters } from "lib/Formarters";
import * as React from "react";
import { useTranslation } from 'react-i18next';

interface IProps {
    startDate?: Date;
    endDate?: Date;
}

type Props = IProps;

const FormattedAvailability: React.FC<Props> = (props) => {
    const { t } = useTranslation();
    const { startDate, endDate } = props;
    const dt = new Date();

    if (startDate == null && endDate == null)
        return null;

    if (startDate != null && endDate == null)
        return <span>{t(`Common.Literals.${startDate > dt ? "AvailableStartAt" : "AvailableStartSince"}`)} {Formaters.fullDateRange(startDate, endDate)}</span>;

    if (startDate == null && endDate != null)
        return <span>{t(`Common.Literals.${endDate > dt ? "AvailableEndsAt" : "AvailableEndsSince"}`)} {Formaters.fullDateRange(startDate, endDate)}</span>;

    return <span><IconCalendar fixedWidth /> {Formaters.fullDateRange(startDate, endDate)}</span>;
};

export default FormattedAvailability;
